import { SvgCheckLine, SvgLineArrow, SvgX } from "assets";
import {
  black,
  gray2,
  gray4,
  gray5,
  gray6,
  gray7,
  gray9,
  kakaoColor,
  mainColor,
  red,
} from "assets/styleUtils";
import { DateField, GuideBox, Header, TextSection } from "components";
import {
  ConvertCompanyClosedHoliday,
  getCompanyDetail,
  IClosedDate,
  ICompany,
  ICompanyClosedDate,
  IProductItem,
  TCompanyClosedHoliday,
  TFormType,
} from "data/company";
import { IUser } from "data/user";
import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from "recoil/atoms";
import { userPhoneCodeSend } from "store/data/user";
import { getToken, post } from "utils/ApiUtil";
import { getParameterObject } from "utils/common";
import styles from "./style.module.css";
import { ButtonModal } from "modal";
import { ExtraDataInputView } from "./ExtraDataInputView";
import { toast, ToastContainer } from "react-toastify";
import { addDirectInquiry, checkInquiry } from "store/data/company";
import { selectListState } from "recoil/company";
import { IButton } from "data/header";
import Lottie from "lottie-react";
import { loadingLottie } from "assets/lottie";
import { headerState } from "recoil/header";
import moment from "moment";
import { MMW_URL } from "assets/constant";
import { exceptCommentCategories } from "pages/CompanyDetailPage/CompanyDetailPage";

export type TDataType =
  | "string"
  | "date"
  | "number"
  | "checkbox"
  | "multiCheckbox"
  | "vacant"
  | "notes"
  | "objects"
  | "time";

export type TInputsData = {
  title: string;
  content: string;
  require: "Y" | "N";
  dataType: TDataType;
  admin_note?: number; //어드민에서만 참고할 내용 숫자 1이면 해당됨
};

export type TExtraData = {
  category?: string;
  content: string;
  dataType: TDataType;
  title: string;
  adminNote: number;
};

export type TSelectProductItem = {
  no: number;
  product_name: string;
  price: number;
  view_price_type?: string;
};

export interface IParams {
  no: string;
}

const initAgreement = {
  privacy: false,
  solution: false,
  require: false,
  kakao: false,
  noPoint: false,
};

type Agreement = typeof initAgreement;
type TAgreementKeys = keyof typeof initAgreement;

const agreementKeys = Object.keys(initAgreement) as TAgreementKeys[];

// const agreements: {
//   content: string;
//   keys: TAgreementKeys;
//   url: string;
//   color: string;
// }[] = [
//   {
//     content: `카톡 메세지의 [접수완료] 버튼을 눌러주셔야
//       예약 접수가 완료되며, 미클릭 시
//       24시간 이후 예약은 자동 취소됩니다.`,
//     url: "",
//     keys: "kakao",
//     color: red,
//   },
//   {
//     content: "개인정보 수집 동의",
//     url: "https://makemywedding.s3.ap-northeast-2.amazonaws.com/terms/1_makemywedding.pdf",
//     keys: "privacy",
//     color: black,
//   },
//   {
//     content: "개인정보 제 3자 제공동의",
//     url: "https://makemywedding.s3.ap-northeast-2.amazonaws.com/terms/2_makemywedding.pdf",
//     keys: "solution",
//     color: black,
//   },
//   {
//     content: "필독 내용을 확인했으며 이에 동의합니다.",
//     url: "",
//     keys: "require",
//     color: black,
//   },
// ];

const baseAgreements: {
  content: string;
  keys: TAgreementKeys;
  url: string;
  color: string;
}[] = [
  {
    content: `카톡 메세지의 [접수완료] 버튼을 눌러주셔야 
      예약 접수가 완료되며, 미클릭 시 
      24시간 이후 예약은 자동 취소됩니다.`,
    url: "",
    keys: "kakao",
    color: red,
  },
  {
    content: "개인정보 수집 동의",
    url: "https://makemywedding.s3.ap-northeast-2.amazonaws.com/terms/1_makemywedding.pdf",
    keys: "privacy",
    color: black,
  },
  {
    content: "개인정보 제 3자 제공동의",
    url: "https://makemywedding.s3.ap-northeast-2.amazonaws.com/terms/2_makemywedding.pdf",
    keys: "solution",
    color: black,
  },
  {
    content: "필독 내용을 확인했으며 이에 동의합니다.",
    url: "",
    keys: "require",
    color: black,
  },
];

export default function EtcInsertEntryInfoPage() {
  const navigate = useNavigate();
  const user = useRecoilValue(userState);
  const setUser = useSetRecoilState(userState);

  const [currentUser, setCurrentUser] = useState<IUser>();
  const [existPhoneNum, setExistPhoneNum] = useState(false);
  const codeNumberRef = useRef<HTMLInputElement | null>(null);
  const [authCode, setAuthCode] = useState<string>();
  const [codeNumber, setCodeNumber] = useState("");
  const [closedDate, setClosedDate] = useState<IClosedDate[]>([]);
  const [closedWeekday, setClosedWeekday] = useState<string>();
  const [closedHoliday, setClosedHoliday] = useState<TCompanyClosedHoliday[]>(
    [],
  );

  const { search } = useLocation();
  const { no } = getParameterObject({ url: search });

  const exceptSelectOfCompany = [
    "예물",
    "플래닝",
    "가전",
    "커텐",
    "매트리스",
    "허니문",
  ];

  const isAuthCode = typeof authCode === "string";
  //방문희망 일자
  const [counselingDateTime, setCounselingDateTime] = useState<TExtraData[]>([
    {
      // category: "counselingDate",
      title: "1순위 날짜",
      dataType: "date",
      content: "",
      adminNote: 0,
    },
    {
      // category: "counselingTime",
      title: "1순위 시간대",
      dataType: "string",
      content: "",
      adminNote: 0,
    },
    {
      // category: "counselingDate",
      title: "2순위 날짜",
      dataType: "date",
      content: "",
      adminNote: 0,
    },
    {
      // category: "counselingTime",
      title: "2순위 시간대",
      dataType: "string",
      content: "",
      adminNote: 0,
    },
    {
      // category: "counselingDate",
      title: "3순위 날짜",
      dataType: "date",
      content: "",
      adminNote: 0,
    },
    {
      // category: "counselingTime",
      title: "3순위 시간대",
      dataType: "string",
      content: "",
      adminNote: 0,
    },
  ]);
  //TODO 빅3페스타 강윤미한복만 250601~250731까지
  const specialNos = ["1240"];
  const deadline = new Date("2025-07-31");

  const isFestaEventTarget = (no: string): boolean => {
    const today = new Date();
    const startDate = new Date("2025-06-01");
    return specialNos.includes(no) && today >= startDate && today <= deadline;
  };

  const isNegotiationEventTarget = (no: string): boolean =>
    no === "2582" || no === "1775";
  //TODO: 25.8월 말 페스타 할인 이벤트까지
  const getFestaEventForm = (): TFormType => ({
    title: "이벤트 참여여부",
    subTitle:
      "* ~2025.08.31까지 빅3 FESTA 진행중인 업체로, 이벤트 참여 시 추가 혜택이 증정되고 있습니다! 참여 여부를 체크해 주세요. \n(참여 시에만 증정되는 혜택으로 미 참여 시 업체 기본 혜택만 제공됩니다.)",
    type: "checkbox",
    content: "",
    checklist: ["참여", "미참여"],
    required_yn: "Y",
    admin_note: 1,
  });

  //TODO: 네고시리즈 이벤트
  const getNegotiationEventForm = (): TFormType => ({
    title: "이벤트 참여여부",
    subTitle:
      "* 네고시리즈 진행중인 업체로, 이벤트 참여 시 추가 혜택 및 최대 20만원 페이백이 증정되고 있습니다! 참여 여부를 체크해 주세요.\n(참여 시에만 증정되는 혜택으로 미 참여 시 업체 기본 혜택만 제공됩니다.)",
    type: "checkbox",
    content: "",
    checklist: ["참여", "미참여"],
    required_yn: "Y",
    admin_note: 1,
  });

  const PersonalWeddingSuit = (
    title: "신랑 예복" | "신랑,신부 한복",
  ): TFormType[] => {
    let baseForms: TFormType[] = [];
    //로드앤테일러
    if (no === "544") {
      baseForms = [
        {
          title: "이용 용도",
          type: "checkbox",
          content: "",
          checklist: ["본식", "촬영", "본식+촬영"],
          required_yn: "Y",
        },
        {
          title,
          type: "checkbox",
          content: "",
          checklist: ["대여", "맞춤"],
          required_yn: "Y",
        },
      ];
    } else {
      baseForms = [
        {
          title: "이용 용도",
          type: "objects",
          content: "",
          checkObject: [
            {
              form_title: "본식",
              form_type: "date",
            },
            {
              form_title: "촬영",
              form_type: "date",
            },
            {
              form_title: "본식+촬영",
              form_type: "string",
              form_placeholder: "예시) 본식: 24년10월3일, 촬영: 24년7월2일",
            },
          ],
          required_yn: "Y",
        },
        {
          title,
          type: "checkbox",
          content: "",
          checklist: ["대여", "맞춤"],
          required_yn: "Y",
        },
      ];
    }

    if (isFestaEventTarget(no)) baseForms.push(getFestaEventForm());
    if (isNegotiationEventTarget(no)) baseForms.push(getNegotiationEventForm());

    return baseForms;
  };

  const ParentsWear = (title: "혼주복" | "혼주 한복"): TFormType[] => {
    const baseForms: TFormType[] = [
      {
        title: "본식 일자",
        type: "date",
        content: "",
        required_yn: "Y",
      },
      {
        title,
        subTitle:
          "* 예약 신청하시는 날짜에 실제로 방문하시는 인원으로 체크해주세요. 방문 인원에 따라 예약 일정이 결정됩니다.\n * 2인 같은날 방문 시 : 혼주 2인으로 체크, 따로 방문 시 : 혼주 1인으로 체크하여 각각 접수해 주세요.",
        type: "checkbox",
        content: "",
        checklist: [
          "혼주 1인 대여(신부측)",
          "혼주 1인 대여(신랑측)",
          "혼주 2인 대여",
          "혼주 1인 맞춤(신부측)",
          "혼주 1인 맞춤(신랑측)",
          "혼주 2인 맞춤",
        ],
        required_yn: "Y",
      },
    ];

    if (isFestaEventTarget(no)) baseForms.push(getFestaEventForm());
    if (isNegotiationEventTarget(no)) baseForms.push(getNegotiationEventForm());

    return baseForms;
  };
  const sendAuthCode = async () => {
    if (currentUser) {
      try {
        const code = Math.random().toFixed(10).substring(2, 6);
        await setAuthCode(code);

        const result = await userPhoneCodeSend({
          phone_number: bride_phone,
          code: code,
        });
        toast.error(
          result.message === "success" ? "전송되었습니다" : "다시 입력해주세요",
        );
      } catch (error) {
        console.error("sendAuthCode error", error);
      }

      // codeNumberRef.current?.focus();
    } else {
      toast.error("로그인 후 재시도해주세요");
    }
  };

  const [bride_name, setBrideName] = useState(user?.name || "");
  const [bride_phone, setBridePhone] = useState(user?.phone_number || "");
  const [groom_name, setGroomName] = useState(user?.groom_name || "");
  const [groom_phone, setGroomPhone] = useState(user?.groom_phone || "");
  const [wedding_day, setWeddingDay] = useState(user?.wedding_day || "");
  const [filming_day, setFilmingDay] = useState(user?.filming_day || "");

  const [agreement, setAgreement] = useState<Partial<Agreement>>({});
  const [extraData, setExtraData] = useState<TInputsData[]>([]);
  const refBrideName = useRef<Text>(null);
  const refBridePhone = useRef<Text>(null);

  const [companyData, setCompanyData] = useState<ICompany>();
  const [showAlert, setShowAlert] = useState(false);
  const [selectCondition, setSelectCondition] = useState<
    "noticeBeforeApply" | "alreayReserve"
  >("noticeBeforeApply");
  const [clickMainItem, setClickMainItem] = useState(false);
  const [clickOptionItem, setClickOptionItem] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const robeOrHanbok =
    companyData?.category === "예복" || companyData?.category === "한복";

  const recoilSelectValue = useRecoilValue(selectListState);
  const setHeader = useSetRecoilState(headerState);
  const tomorrow = moment().add(1, "days").format("YYYY-MM-DD");

  const strClosedDate =
    closedWeekday ||
    ((companyData?.spotlist || []).length > 1
      ? ""
      : companyData?.restday || "");
  const strClosedHoliday = closedHoliday
    .map((holiday) => ConvertCompanyClosedHoliday[holiday] || "")
    .join(", ");
  const strRestday = `${!!strClosedDate ? `매주 ${strClosedDate}` : ""}${
    !!strClosedDate && !!strClosedHoliday ? ", " : ""
  }${!!strClosedHoliday ? `공휴일(${strClosedHoliday})` : ""}`;
  const restday = strRestday.length > 0 ? strRestday : undefined;

  const agreements = [
    ...baseAgreements,
    ...(companyData?.advertising_yn === "Y"
      ? [
          {
            content: "해당 업체는 계약 포인트 미지급 업체입니다.",
            url: "",
            keys: "noPoint",
            color: black,
          } as const,
        ]
      : []),
  ];

  const exceptSpouseCategories = [
    "플래닝",
    "홈스타일링",
    "리부케기프트",
    "퍼스널컬러",
    "웨딩카",
    "헤어변형",
    "혼주 메이크업",
    "플라워",
    "청첩장",
  ]; //배우자 정보 제외하는 카테고리
  const invalidNumbers = [
    "01011111111",
    "01012341234",
    "01012341111",
    "01000000000",
    "01022222222",
    "01033333333",
    "01044444444",
    "01055555555",
    "01066666666",
    "01077777777",
    "01088888888",
    "01099999999",
    "01012121212",
    "01013131313",
    "01012312312",
    "01011223344",
    "01010101010",
    "01098765432",
    "01000011111",
  ];
  // 의미 없는 번호 리스트

  const [selectProductItem, setSelectProductItem] =
    useState<TSelectProductItem>({
      no: 0,
      product_name: "",
      price: 0,
      view_price_type: "",
    });
  const [selectProductOptionItem, setSelectProductOptionItem] = useState<
    TSelectProductItem[]
  >([]);
  const mainItemRef = useRef<HTMLDivElement>(null);
  const optionItemRef = useRef<HTMLDivElement>(null);

  const calculateDiscountPrice = (
    price: number,
    discount_price: number,
    view_price_type: "price" | "rate" | "krw" | "etc" | undefined,
  ): number => {
    return view_price_type === "rate"
      ? Number(price) - (Number(price) * Number(discount_price)) / 100
      : view_price_type === "krw"
      ? price
      : discount_price;
  };

  const toggleOptionItem = (optionItem: IProductItem) => {
    setSelectProductOptionItem((prevOptions) => {
      const exists = prevOptions.some((option) => option.no === optionItem.no);

      if (!exists) {
        const newOption: TSelectProductItem = {
          no: optionItem.no,
          product_name: optionItem.product_name,
          price: calculateDiscountPrice(
            optionItem.product_price,
            optionItem.product_discount_price,
            optionItem.view_price_type,
          ),
          view_price_type: optionItem.view_price_type,
        };
        return [...prevOptions, newOption];
      }
      return prevOptions.filter((prev) => prev.no !== optionItem.no);
    });
  };

  async function getCompanyData(companyId: number) {
    try {
      const {
        data: { result, closed_holidays },
      } = await getCompanyDetail(companyId);
      function getAppropriateForm(
        category: string,
        type: string,
        contructor_no: number,
      ) {
        let _data: TFormType[] | null = null;
        switch (`${category}-${type}`) {
          case "예복-parentsWear":
            _data = ParentsWear("혼주복");
            break;
          case "예복-weddingSuit":
            _data = PersonalWeddingSuit("신랑 예복");
            break;
          case "한복-parentsWear":
            _data = ParentsWear("혼주 한복");
            break;
          case "한복-weddingSuit":
            _data = PersonalWeddingSuit("신랑,신부 한복");
            break;
        }
        if (contructor_no === 544 && !!_data) {
          // 로드앤테일러
          if (type === "parentsWear") {
            _data.push({
              title: "본식 장소",
              type: "string",
              content: "",
              required_yn: "Y",
            });
          } else if (type === "weddingSuit") {
            _data.push({
              title: "촬영 장소",
              type: "string",
              content: "",
              required_yn: "Y",
            });
            _data.push({
              title: "촬영 날짜",
              type: "date",
              content: "",
              required_yn: "Y",
            });
            _data.push({
              title: "본식 장소",
              type: "string",
              content: "",
              required_yn: "Y",
            });
            _data.push({
              title: "본식 날짜",
              type: "date",
              content: "",
              required_yn: "Y",
            });
          }
        }
        return _data;
      }
      if (result) {
        const commonForm: TFormType = {
          title: `타경로를 통해 예약 또는 문의하신 이력이 있으신가요? `,
          subTitle:
            "타경로: 타플랫폼/플래닝/타업체/워크인/네이버예약/카톡문의 등",
          type: "checkbox",
          content: "",
          checklist: ["예", "아니요"],
          required_yn: "Y",
          admin_note: 1,
        };
        if (result.category === "예복" || result.category === "한복") {
          const type = recoilSelectValue.clothesCheckData[0].type || "";
          if (["parentsWear", "weddingSuit"].includes(type)) {
            const form = getAppropriateForm(result.category, type, result.no);
            if (form) {
              setCompanyData({
                ...result,
                form: [...form, commonForm],
              });
            }
          }
        } else {
          const existingForm = result.form || [];
          const extendedForm = [...existingForm];
          if (isFestaEventTarget(no)) extendedForm.push(getFestaEventForm());
          setCompanyData({
            ...result,
            form: [...extendedForm, commonForm],
          });
        }

        const selected_spot_no = recoilSelectValue?.spotCheckData[0]?.no;
        const default_closed_date = result.closed_date || [];
        const closedDateList = !selected_spot_no
          ? default_closed_date
          : default_closed_date.filter(
              (item) => item.contructor_spot_no === selected_spot_no,
            );
        const initClosedDateList: IClosedDate[] = closedDateList.map(
          (item) => ({ closed_date: item.closed_date }),
        );

        const closedHoliday = !selected_spot_no
          ? result.closed_holidays
          : (result.spotlist || []).find((item) => item.no === selected_spot_no)
              ?.closed_holidays;
        const closedHolidayList = (closedHoliday || "")
          .split(",")
          .filter((item) => !!item) as TCompanyClosedHoliday[];

        closedHolidayList.map((holiday) => {
          if (holiday in (closed_holidays || {})) {
            closed_holidays[holiday].map((closed_date) => {
              initClosedDateList.push({ closed_date });
            });
          }
        });

        setClosedHoliday(closedHolidayList);
        setClosedDate(initClosedDateList);

        const closedWeekday = !selected_spot_no
          ? result.closed_weekdays
          : (result.spotlist || []).find((item) => item.no === selected_spot_no)
              ?.closed_weekdays;
        setClosedWeekday(closedWeekday);
      }
    } catch (error) {
      console.error("getCompanyData error", error);
    }
  }

  const isAllAgreeTerms =
    Object.values(agreement).filter((agree) => !agree).length === 0;
  const isExtraComplete = () => {
    switch (companyData?.category) {
      default:
        const requireCount = extraData.reduce((acc, item) => {
          return item.require === "Y" ? acc + 1 : acc;
        }, 0);

        const filteredItems = extraData.filter(
          (item) => item.require === "Y" && item.content !== "",
        );
        const checkCounselingDateTime =
          companyData?.visit_yn === "Y"
            ? counselingDateTime.filter((item) => item.content === "")
            : [];
        const checkObjectFilter = extraData.filter(
          (item) =>
            item.dataType === "objects" &&
            item.content.includes(",") &&
            !item.content.split(",")[1],
        );
        const checkSelectMainItem =
          (
            (!exceptSelectOfCompany.includes(companyData?.category as string) &&
              companyData?.productitem?.main) ||
            []
          ).length > 0 && !robeOrHanbok
            ? selectProductItem.product_name !== ""
            : true;

        const checkToAgree =
          companyData?.category === "가전"
            ? extraData.some((data) => data.content.includes("미동의"))
            : false;

        return (
          filteredItems.length === requireCount &&
          checkObjectFilter.length === 0 &&
          checkCounselingDateTime.length === 0 &&
          !checkToAgree &&
          !!checkSelectMainItem
        );
    }
  };

  const changeUserPhoneNumber = (text: string) => {
    setExistPhoneNum(false);
    setBridePhone(text);
  };
  const isCheckingTodayDate = () => {
    const today = moment().startOf("day");

    const hasTodayDate = extraData.some((item) => {
      const contentDate = moment(item.content).startOf("day");
      return contentDate.isSame(today, "day");
    });
    const counselingHasTodayDate = counselingDateTime.some((item) => {
      const contentDate = moment(item.content).startOf("day");
      return contentDate.isSame(today, "day");
    });
    return !hasTodayDate && !counselingHasTodayDate;
  };
  const errorMsg = (function () {
    if (bride_name.length <= 1) {
      return "신청자 이름을 입력해주세요.";
    }

    if (!existPhoneNum) {
      return "신청자 전화번호를 인증해주세요.";
    }

    if (!bride_phone.match(/^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/)) {
      return "신청자 전화번호를 정확히 입력해주세요.";
    }
    if (
      companyData?.category &&
      !exceptSpouseCategories.includes(companyData?.category)
    ) {
      if (groom_name.length <= 1) {
        return "배우자 이름을 입력해주세요.";
      }
      if (groom_phone.length !== 11) {
        return "배우자 전화번호를 입력해주세요.";
      }
      if (groom_name === bride_name) {
        return "배우자 이름은 동일할 수 없습니다.";
      }
      if (groom_phone === bride_phone) {
        return "배우자 전화번호는 동일할 수 없습니다.";
      }
      if (groom_phone === bride_phone) {
        return "배우자 전화번호는 동일할 수 없습니다.";
      }
      if (!groom_phone.match(/^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/)) {
        return "배우자 전화번호를 정확히 입력해주세요.";
      }
      if (invalidNumbers.includes(groom_phone)) {
        return "배우자 전화번호를 정확히 입력해주세요.";
      }
    }
    if (!isExtraComplete()) {
      return "업체 정보를 입력해주세요";
    }
    if (!agreement.privacy) {
      return "예약 문의를 위해 약관동의가 필요해요";
    }
    if (!agreement.solution) {
      return "예약 문의를 위해 약관동의가 필요해요";
    }
    if (!agreement.kakao) {
      return "예약 문의를 위해 약관동의가 필요해요";
    }
    if (!isCheckingTodayDate()) {
      return "오늘 날짜는 선택할 수 없습니다";
    }
  })();

  const isComplete =
    bride_phone.length === 11 &&
    bride_name.length > 1 &&
    bride_phone.match(/^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/) &&
    !!isAllAgreeTerms &&
    !!isCheckingTodayDate() &&
    !!isExtraComplete() &&
    !errorMsg;

  const authCheck = async () => {
    if (codeNumber === authCode) {
      toast.success("인증되었습니다");
      setAuthCode(undefined);
      setExistPhoneNum(true);
      ////updatesignup으로 핸드폰번호 보내기
      await post("/api/user/updatesignup", { phone_number: bride_phone });
      setUser(user && { ...user, phone_number: String(bride_phone) });
    } else {
      toast.error("다시 입력해주세요");
    }
  };

  setHeader({
    isVisible: true,
    title: "예약 문의",
    url: `-1`,
    right: {
      onClick: () => {
        if (isComplete && !isLoading) {
          setShowAlert(true);
          setSelectCondition("noticeBeforeApply");
        } else {
          toast.error(errorMsg);
        }
      },
      text: `완료`,
      color: isComplete && !isLoading ? mainColor : gray5,
    },
  });

  const handleGroomNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toString();
    if (value === bride_name) {
      toast.error("배우자 이름은 동일할 수 없습니다.");
      return;
    }
    setGroomName(value);
  };

  const handleGroomPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length > 11) return;

    if (value === bride_phone) {
      toast.error("배우자 전화번호는 동일할 수 없습니다.");
      return;
    }

    if (invalidNumbers.includes(value)) {
      toast.error("유효하지 않은 전화번호입니다.");
      return;
    }

    setGroomPhone(value);
  };

  const throttledRequireEntryInquiry = _.throttle(
    async ({
      bride_name,
      bride_phone,
      groom_name,
      groom_phone,
      wedding_day,
      filming_day,
      extra_data,
      select_item_list,
    }: {
      bride_name: string;
      bride_phone: string;
      groom_name: string;
      groom_phone: string;
      wedding_day: string;
      filming_day: string;
      extra_data?: TExtraData[];
      select_item_list?: { product_no: number }[];
    }) => {
      if (!!companyData) {
        try {
          const res = await addDirectInquiry({
            contructor_no: companyData.no,
            contructor_spot_no: recoilSelectValue?.spotCheckData[0]?.no || null,
            title: companyData.name,
            bride_name,
            bride_phone,
            groom_name,
            groom_phone,
            wedding_day,
            filming_day,
            extra_data,
            select_item_list,
          });

          if (res.success) {
            toast.success("문의가 완료되었습니다.");
            setTimeout(() => {
              setIsLoading(false);
              const hasSpotData = recoilSelectValue?.spotCheckData.length > 0;
              const hasClothesData =
                recoilSelectValue?.clothesCheckData.length > 0;

              if (hasSpotData && hasClothesData) {
                return navigate(-3);
              } else if (hasSpotData || hasClothesData) {
                return navigate(-2);
              } else {
                return navigate(-1);
              }
            }, 2000);
          }
        } catch (error) {
          console.error("error", error);
          toast.error(`에러가 발생했습니다.${error} `);
          setIsLoading(false);
        }
      }
    },
    1000,
  );
  const extraDataRecombine = extraData.map((data) => {
    return {
      title: data.title,
      dataType: data.dataType,
      content: data.content,
      adminNote: data.admin_note ?? 0,
    };
  });
  const selectItemRecombine = selectProductOptionItem.map((item) => {
    return {
      product_no: item.no,
    };
  });
  const selectItemAddOptionItem = selectItemRecombine.concat({
    product_no: selectProductItem.no,
  });

  const checkEntry = async () => {
    if (!!isLoading) {
      return;
    }
    setIsLoading(true);

    if (!!companyData) {
      try {
        const res = await checkInquiry({
          contructor_no: companyData.no,
          contructor_spot_no: recoilSelectValue?.spotCheckData[0]?.no,
          extra_data_title: recoilSelectValue?.clothesCheckData[0]?.name,
        });
        if (res.success) {
          throttledRequireEntryInquiry({
            bride_name: bride_name || "",
            bride_phone: bride_phone || "",
            groom_name: groom_name || "",
            groom_phone: groom_phone || "",
            wedding_day: wedding_day || "",
            filming_day: filming_day || "",
            extra_data:
              companyData?.visit_yn === "Y" || robeOrHanbok
                ? extraDataRecombine.concat(counselingDateTime)
                : extraDataRecombine,
            select_item_list:
              (companyData?.productitem?.main || []).length > 0 &&
              !robeOrHanbok &&
              !exceptSelectOfCompany.includes(companyData?.category as string)
                ? selectItemAddOptionItem
                : [],
          });
        } else {
          setShowAlert(true);
          setSelectCondition("alreayReserve");
        }
      } catch (error) {
        console.error("checkInquiry error");
        setShowAlert(true);
        setSelectCondition("alreayReserve");
        setIsLoading(false);
      }
    }
  };

  const handleDateChange = (date: string, index: number) => {
    const today = moment().startOf("day");
    const selectedDate = moment(date).startOf("day");
    if (selectedDate.isSameOrBefore(today)) {
      return;
    }
    const duplicateIndex = counselingDateTime.filter(
      (item) => item.content === date,
    );
    if (duplicateIndex.length > 0) {
      return toast.error("1~3순위 동일한 날짜 선택이 불가합니다.");
    } else {
      setCounselingDateTime((prev) =>
        prev.map((item, prevIndex) =>
          index === prevIndex ? { ...item, content: date } : item,
        ),
      );
    }
  };

  //모달창띄우기
  function showModalBasedOnCondition(
    condition: "noticeBeforeApply" | "alreayReserve",
  ) {
    let modalTitle = "";
    let subTitle = "";
    let oneButton = { color: "", text: "", onClick: () => setShowAlert(false) };
    let twoRightButton;

    switch (condition) {
      case "noticeBeforeApply":
        (modalTitle = "주의사항"),
          (subTitle = `*어플을 통한 예약 취소 및 변경은 각 1회씩 예약된 날짜로부터 3일 전까지만 가능하며, 2일 이내일 경우 업체에 직접 신청해 주셔야 합니다.

       *이미 변경 및 취소하신 이력이 있으셔서 예약이 불가한 경우, 챗봇을 통해 문의 주세요.
    
       *최초 신청건만 예약 가능합니다.
       (이미 업체에 예약 및 문의하신 이력이 있으실 경우 예약,혜택 및 포인트 지급 불가, 패널티
       부여)
    
       *<span style="color: red">필독사항에 패널티 관련된 내용을 꼭 필독하여 주세요.</span>`),
          (oneButton = {
            color: gray4,
            text: "동의하지 않습니다",
            onClick: () => setShowAlert(false),
          }),
          (twoRightButton = {
            color: mainColor,
            text: "동의합니다",
            onClick: () => {
              setShowAlert(false);
              setTimeout(() => {
                checkEntry();
              }, 500);
            },
          });
        break;
      case "alreayReserve":
        modalTitle = "안내사항";
        subTitle =
          "해당업체에 예약 신청 및 취소 이력이 있으셔서 추가 접수는 불가합니다. \n재예약을 원하시는 경우 \n챗봇으로 신청해 주세요! :) ";
        oneButton = {
          color: gray4,
          text: "뒤로가기",
          onClick: () => setShowAlert(false),
        };
        twoRightButton = undefined;
        break;
    }
    return modalState({
      title: modalTitle,
      sub: subTitle,
      oneButton: oneButton,
      twoRightButton: twoRightButton,
    });
  }

  const modalState = ({
    title,
    sub,
    oneButton,
    twoRightButton,
  }: {
    title: string;
    sub: string;
    oneButton: IButton;
    twoRightButton?: IButton;
  }) => {
    return (
      <ButtonModal
        title={title}
        sub={sub}
        oneButton={{
          color: oneButton.color || "",
          text: oneButton.text || "",
          onClick: oneButton.onClick || (() => {}),
        }}
        twoRightButton={{
          color: twoRightButton?.color || "",
          text: twoRightButton?.text || "",
          onClick: twoRightButton?.onClick || (() => {}),
        }}
      />
    );
  };

  const useOutsideClick = (
    ref: React.RefObject<HTMLDivElement>,
    callback: () => void,
  ) => {
    useEffect(() => {
      const handleClick = (e: any) => {
        if (ref.current && !ref.current.contains(e.target)) {
          callback();
        }
      };
      document.addEventListener("mousedown", handleClick);

      return () => {
        document.removeEventListener("mousedown", handleClick);
      };
    }, [ref, callback]);
  };

  const DropdownItem = ({
    item,
    onClick,
  }: {
    item: IProductItem;
    onClick: () => void;
  }) => {
    const displayPrice = calculateDiscountPrice(
      item.product_price,
      item.product_discount_price,
      item.view_price_type,
    );

    return (
      <div className={styles.dropdownItem} onClick={onClick}>
        <div className={styles.dropdownText}>{item.product_name}</div>
        <div
          className={styles.dropdownText}
          style={{
            width: "100px",
            marginRight: "10px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {item.view_price_type === "etc"
            ? "업체문의"
            : `${Number(displayPrice).toLocaleString()}원`}
        </div>
      </div>
    );
  };

  //드롭다운 감지
  useOutsideClick(mainItemRef, () => setClickMainItem(false));
  useOutsideClick(optionItemRef, () => setClickOptionItem(false));

  useEffect(() => {
    setCurrentUser(user);
    if (user?.phone_number) {
      setExistPhoneNum(true);
    }
  }, []);

  useEffect(() => {
    if (!!no) {
      getCompanyData(Number(no));
    }
  }, []);

  // 광고 여부 변동 시 재구성
  useEffect(() => {
    const keys =
      companyData?.advertising_yn === "N"
        ? agreementKeys.filter((k) => k !== "noPoint")
        : agreementKeys;

    setAgreement((prev) =>
      keys.reduce<Partial<Agreement>>(
        (acc, k) => ({ ...acc, [k]: prev[k] ?? false }),
        {},
      ),
    );
  }, [companyData?.advertising_yn]);
  return (
    <>
      {showAlert && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0,0,0,0.4)",
              zIndex: "200",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setShowAlert(false);
            }}
          >
            {showModalBasedOnCondition(selectCondition)}
          </div>
        </>
      )}
      <div>
        {!!isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: 300,
              padding: 50,
            }}
          >
            <Lottie animationData={loadingLottie} loop={true} />
          </div>
        ) : (
          <div
            style={{
              padding: "32px 24px",
            }}
          >
            <h2 style={{ color: gray5 }}> 원활한 상담을 위해</h2>
            <h2> 회원님의 정보가 필요합니다.</h2>
            <div style={{ height: "20px" }} />
            {!!companyData && (
              <div className={styles.companyData}>
                <div className={styles.companyDataTitle}>
                  <div>업체명</div>
                  <div>{companyData.name}</div>
                </div>
                {!!companyData.openhour && (
                  <div className={styles.companyDataTitle}>
                    <div>영업시간</div>
                    <div>{companyData.openhour}</div>
                  </div>
                )}
                {!!restday && (
                  <div className={styles.companyDataTitle}>
                    <div>휴무일</div>
                    <div>{restday}</div>
                  </div>
                )}
                {!!companyData.reservation_caution && (
                  <div className={styles.companyDataTitle}>
                    <div>주의사항</div>

                    <div>
                      {companyData.reservation_caution
                        .split("\n")
                        .map((context, index) => (
                          <TextSection data={context} key={index} />
                        ))}
                    </div>
                  </div>
                )}
              </div>
            )}
            <div
              style={{
                padding: "16px",
                border: `1px solid ${gray7}`,
                borderRadius: "4px",
              }}
            >
              <div className={styles.commonInfo}>
                <SvgCheckLine color={gray2} width="18px" />
                <div className={styles.defaultInformInput}> 기본 정보 입력</div>
              </div>
              <div style={{ color: gray5, fontSize: "12px" }}>
                상담을 위해 필요한 정보이니 정확하게 기재해주세요.
              </div>
              <div style={{ height: "20px" }} />
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    width: "100px",
                    marginTop: "10px",
                  }}
                >
                  신청자 정보
                </div>
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <input
                    className={styles.commonInput}
                    placeholder="이름 입력"
                    defaultValue={bride_name}
                    onChange={(e) => setBrideName(e.target.value)}
                  />
                  <div style={{ display: "flex" }}>
                    <input
                      className={styles.commonInput}
                      style={{ width: "70%" }}
                      placeholder="전화번호 입력(-제외)"
                      type="number"
                      defaultValue={currentUser?.phone_number}
                      maxLength={11}
                      onChange={(e) =>
                        changeUserPhoneNumber(e.target.value.toString())
                      }
                    />
                    <div
                      style={{
                        color: existPhoneNum ? "green" : "red",
                        width: "30%",
                      }}
                      className={styles.commonTextButton}
                      onClick={() => {
                        if (!existPhoneNum) {
                          if (bride_phone?.length === 11) {
                            sendAuthCode();
                          } else {
                            toast.error("휴대폰 번호가 일치하지않습니다.");
                          }
                        } else {
                        }
                      }}
                    >
                      {existPhoneNum ? "인증됨" : "인증하기"}
                    </div>
                  </div>
                  {isAuthCode && (
                    <>
                      <div style={{ display: "flex" }}>
                        <input
                          ref={codeNumberRef}
                          maxLength={4}
                          className={styles.commonInput}
                          style={{ padding: "0 8px", width: "70%" }}
                          value={codeNumber}
                          onChange={(e) =>
                            setCodeNumber(e.target.value.toString())
                          }
                          placeholder="인증코드 4자리"
                        />
                        <div
                          style={{
                            width: "30%",
                            backgroundColor: gray9,
                            borderRadius: "3px",
                          }}
                          className={styles.commonTextButton}
                          onClick={authCheck}
                        >
                          <div>확인</div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          marginLeft: "3px",
                          marginTop: "7px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "500",
                            color: gray5,
                            fontSize: "12px",
                          }}
                        >
                          인증번호가 오지 않았나요?
                        </div>
                        <div onClick={sendAuthCode} style={{ height: "30px" }}>
                          <div
                            style={{
                              fontWeight: "500",
                              color: mainColor,
                              fontSize: "12px",
                              marginLeft: "12px",
                            }}
                          >
                            재발송
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {companyData?.category &&
                !exceptSpouseCategories.includes(companyData?.category) && (
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "100px",
                        marginTop: "10px",
                      }}
                    >
                      배우자 정보
                    </div>
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <input
                        className={styles.commonInput}
                        placeholder="이름 입력"
                        defaultValue={groom_name}
                        onChange={handleGroomNameChange}
                      />
                      <div style={{ display: "flex" }}>
                        <input
                          className={styles.commonInput}
                          style={{ width: "100%" }}
                          placeholder="전화번호 입력(-제외)"
                          type="number"
                          defaultValue={currentUser?.groom_phone}
                          maxLength={11}
                          onChange={handleGroomPhoneChange}
                        />
                      </div>
                    </div>
                  </div>
                )}
              <div className={styles.commonInfo} style={{ marginTop: "30px" }}>
                <SvgCheckLine color={gray2} width="18px" />
                <div className={styles.defaultInformInput}>
                  업체 정보 입력{"  "}
                  <span style={{ fontSize: "13px", color: gray4 }}>
                    (* 는 필수 정보 입력입니다.)
                  </span>
                </div>
              </div>
              {(companyData?.productitem?.main || []).length > 0 &&
                !exceptSelectOfCompany.includes(
                  companyData?.category as string,
                ) &&
                !robeOrHanbok && (
                  <div>
                    <div className={styles.titleStyle}>상품선택 *</div>
                    <div ref={mainItemRef} style={{ position: "relative" }}>
                      <div
                        className={styles.commonInput}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                        onClick={() => setClickMainItem(!clickMainItem)}
                      >
                        <div
                          style={{
                            marginTop: "-5px",
                          }}
                        >
                          상품선택
                        </div>
                        <div style={{ marginTop: "-5px" }}>
                          <SvgLineArrow
                            direction={clickMainItem ? "Down" : "Up"}
                          />
                        </div>
                      </div>
                      {!!selectProductItem.no && (
                        <div className={styles.dropdownBottomLine}>
                          <div className={styles.productItem}>
                            <div>{selectProductItem.product_name}</div>
                            <div>
                              {selectProductItem.view_price_type === "etc"
                                ? "업체문의"
                                : `${Number(
                                    selectProductItem.price,
                                  ).toLocaleString()}
                              원`}
                            </div>
                          </div>
                          <div
                            onClick={() =>
                              setSelectProductItem((prevOptions) => {
                                return prevOptions.no === selectProductItem.no
                                  ? {
                                      no: 0,
                                      product_name: "",
                                      price: 0,
                                      view_price_type: "",
                                    }
                                  : prevOptions;
                              })
                            }
                          >
                            <SvgX width={15} height={15} />
                          </div>
                        </div>
                      )}
                      {!!clickMainItem && (
                        <div className={styles.dropdownContainer}>
                          {companyData?.productitem?.main.map(
                            (mainItem, index) => (
                              <DropdownItem
                                key={index}
                                item={mainItem}
                                onClick={() => {
                                  setSelectProductItem({
                                    no: mainItem.no,
                                    product_name: mainItem.product_name,
                                    price: calculateDiscountPrice(
                                      mainItem.product_price,
                                      mainItem.product_discount_price,
                                      mainItem.view_price_type,
                                    ),
                                    view_price_type: mainItem.view_price_type,
                                  });
                                  setClickMainItem(!clickMainItem);
                                }}
                              />
                            ),
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              {(companyData?.productitem?.option || []).length > 0 &&
                !exceptSelectOfCompany.includes(
                  companyData?.category as string,
                ) &&
                !robeOrHanbok && (
                  <div>
                    <div className={styles.titleStyle}>추가상품</div>
                    <div ref={optionItemRef} style={{ position: "relative" }}>
                      <div
                        className={styles.commonInput}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                        onClick={() => setClickOptionItem(!clickOptionItem)}
                      >
                        <div style={{ marginTop: "-5px" }}>추가상품</div>
                        <div style={{ marginTop: "-5px" }}>
                          <SvgLineArrow
                            direction={clickOptionItem ? "Down" : "Up"}
                          />
                        </div>
                      </div>
                      {!!clickOptionItem && (
                        <div className={styles.dropdownContainer}>
                          {companyData?.productitem?.option.map(
                            (optionItem, index) => (
                              <DropdownItem
                                key={index}
                                item={optionItem}
                                onClick={() => {
                                  toggleOptionItem(optionItem);
                                  setClickOptionItem(!clickOptionItem);
                                }}
                              />
                            ),
                          )}
                        </div>
                      )}
                    </div>
                    {selectProductOptionItem.length > 0 &&
                      selectProductOptionItem.map((option, index) => (
                        <div key={index} className={styles.dropdownBottomLine}>
                          <div className={styles.productItem}>
                            <div>{option.product_name}</div>
                            <div>
                              {option.view_price_type === "etc"
                                ? "업체문의"
                                : `${Number(option.price).toLocaleString()}`}
                              원
                            </div>
                          </div>
                          <div
                            onClick={() =>
                              setSelectProductOptionItem((prevOptions) => {
                                const exists = prevOptions.some(
                                  (prev) => prev.no === option.no,
                                );
                                if (!!exists) {
                                  return prevOptions.filter(
                                    (prev) => prev.no !== option.no,
                                  );
                                } else {
                                  return prevOptions;
                                }
                              })
                            }
                          >
                            <SvgX width={15} height={15} />
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              {companyData?.form_open_yn === "Y" &&
                (companyData?.visit_yn === "Y" || !!robeOrHanbok) && (
                  <div>
                    <div className={styles.titleStyle}>방문 희망 일자 *</div>
                    <div
                      style={{
                        fontWeight: "500",
                        lineHeight: "23px",
                        color: gray4,
                        marginTop: "10px",
                      }}
                    >
                      <div>
                        * 3순위까지 각각 다른 날짜로 입력해주세요.
                        <br /> 모두 동일한 날짜로 입력 시 예약이 불가한 날짜인
                        경우 자동으로 취소됩니다.
                      </div>
                      <div style={{ marginTop: "5px" }}>
                        * 방문 시간대 범위를 넓게 잡아주세요! 딱 한타임으로만
                        적어주실 경우 예약 잡기가 매우 어렵습니다.
                      </div>
                      {exceptCommentCategories.includes(
                        companyData.category,
                      ) && (
                        <div style={{ marginTop: "5px" }}>
                          * 예약 접수를 하시게되면 실제 방문하시는 일정으로
                          예약이 진행되며, &nbsp;
                          <span style={{ color: red }}>
                            단순 견적 문의는 불가합니다.
                          </span>
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "row",
                        flexWrap: "wrap",
                      }}
                    >
                      {counselingDateTime.map((data, index) => {
                        if (index % 2 === 0) {
                          return (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                width: "100%",
                              }}
                              key={index}
                            >
                              <div
                                style={{
                                  width: "50%",
                                  padding: "5px",
                                }}
                              >
                                <div>{data.title}</div>
                                <DateField
                                  index={index}
                                  style={{ width: "100%" }}
                                  onChange={(date: string) =>
                                    handleDateChange(date, index)
                                  }
                                  value={counselingDateTime[index].content}
                                  min={tomorrow}
                                  closedDate={closedDate}
                                  closedWeekday={closedWeekday}
                                />
                              </div>
                              {counselingDateTime[index + 1] && (
                                <div style={{ width: "50%", padding: "5px" }}>
                                  <div>
                                    {counselingDateTime[index + 1].title}
                                  </div>
                                  <input
                                    type="text"
                                    style={{
                                      width: "100%",
                                      height: "45px",
                                    }}
                                    className={styles.commonInput}
                                    placeholder="예) 14~17시 사이"
                                    onChange={(e) => {
                                      setCounselingDateTime((prev) =>
                                        prev.map((item, prevIndex) =>
                                          index + 1 === prevIndex
                                            ? {
                                                ...item,
                                                content: e.target.value,
                                              }
                                            : item,
                                        ),
                                      );
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                )}
              {companyData?.form_open_yn === "Y" && (
                <ExtraDataInputView
                  companyFormData={companyData?.form}
                  setExtraData={setExtraData}
                />
              )}
            </div>
            <div style={{ margin: "15px 0" }}>
              {agreements.map(({ content, url, keys, color }, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      onClick={() =>
                        setAgreement({ ...agreement, [keys]: !agreement[keys] })
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          height: 40,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "12px",
                            height: 30,
                            marginRight: 10,
                            cursor: "pointer",
                          }}
                        >
                          <SvgCheckLine
                            fill={agreement[keys] ? mainColor : gray6}
                          />
                        </div>
                        <div
                          style={{
                            fontWeight: "500",
                            color,
                            lineHeight: "120%",
                          }}
                        >
                          {content}
                        </div>
                      </div>
                    </div>
                    {!!url && (
                      <div
                        style={{ paddingLeft: 10 }}
                        onClick={() => {
                          navigate(`/PDFPage/${i}`);
                        }}
                      >
                        <img
                          style={{
                            width: 13,
                            height: 13,
                            cursor: "pointer",
                          }}
                          src={"/images/right.png"}
                          alt="Right Arrow"
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <GuideBox
              title="*필독*"
              pdb={10}
              list={[
                "예약 문의를 주시면 업체 측 확인 후 순차적으로 안내 드립니다.",
                "원활한 예약센터 운영을 위해 타 고객 예약에 영향을 미치거나 업체 측 업무에 혼선을 줄 수 있는 경우 (예약 신청 후 업체 측 연락을 받지 않으시거나, 미회신/예약 신청일 당일 취소 요청/예약 확정일 당일 취소 요청/방문 예약 후 노쇼/이미 예약 된 이후 중복 접수 등)의 경우 패널티가 부여됩니다. <br/><span>(패널티 : 어플&베뉴 예약센터 이용 불가)</span>",
                "메이크마이웨딩을 통한 '최초' 예약일 경우에만 예약이 가능합니다. 업체에 이미 예약 및 문의하신 이력이 있으신 경우 중복으로 접수되지 않으며, 예약 후 취소하신 경우에도 중복에 해당되어 메이크마이웨딩을 통한 예약 및 혜택 지급은 불가합니다.<span>  <br/> (멕마웨 접수 후 예약 확정 전 업체에 문의/타경로/타업체/직접 연락을 통한 예약 또는 문의/카카오톡/문자/전화/SNS 메세지 단순 문의 등)</span>",
                "방문일을 기재해야 하는 업체는 반드시 1~3순위까지 각각 '다른' 날짜로 입력 부탁드리며, 우선순위 순으로 상담 가능한 시간으로 예약을 잡아드립니다. ",
                "당일 방문 신청건은 예약이 어려울 수 있으며, 특히 주말 및 공휴일에 당일 방문으로 신청하시는 경우는 예약 자체가 불가합니다. 방문 일자를 넉넉한 일정으로 신청해 주세요.",
                "제휴 상황에 따라 혜택 제공이 변동될 수 있습니다.",
                "메이크마이웨딩 어플을 통한 계약이 아니신 경우 포인트 적립 및 혜택 적용이 불가합니다.",
                "<span>주말 및 공휴일, 영업시간 이후의 문의 건은 업체 측에 전달이 늦어질 수 있습니다. <br/> (메이크마이웨딩 영업시간: 월 ~ 금, 09:00 ~ 18:00 , 토요일 9:00 ~ 12:00)</span>",
              ]}
            />
            <div style={{ height: "50px" }} />
          </div>
        )}
        <ToastContainer
          position="bottom-center"
          limit={1}
          closeButton={false}
          autoClose={1300}
          theme="light"
        />
      </div>
    </>
  );
}
